export const sitesWithArrows = ['case-studies', 'referenzen', 'references', 'referencias', 'referenties', 'referenze'];
